module.exports = __webpack_public_path__ + "img/table-sort-light.88ec2240.svg";